export default __webpack_public_path__ + "static/media/trr-drink-wine-rose.9985937b.png";